import { AuthProvider } from '@/contexts/auth-context';
import { ChartProvider } from '@/contexts/chart-context';
import { CommonProvider } from '@/contexts/common-context';
import { HealthCheckProvider } from '@/contexts/health-check-context';
import { OrganizationProvider } from '@/contexts/organization-context';
import { RBACProvider } from '@/contexts/rbac-context';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import 'leaflet/dist/leaflet.css';
import './styles/map.css';
import './globals.css';
import './styles/print-invoice.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ChartProvider>
        <AuthProvider>
          <HealthCheckProvider>
            <RBACProvider>
              <OrganizationProvider>
                <CommonProvider>
                  <App />
                </CommonProvider>
              </OrganizationProvider>
            </RBACProvider>
          </HealthCheckProvider>
        </AuthProvider>
      </ChartProvider>
    </BrowserRouter>
  </React.StrictMode>
);
